module.exports = __webpack_public_path__ + "img/lr.be66b7a3.svg";